import { useNavigate } from "react-router-dom";
import ScrollToTopButton from "../../components/ScrollToTopButton";
import { Banner, BlueLarge } from "../../images/index";
import {
  Image306,
  G1,
  G2,
  G3,
  G4,
  G5,
  G6,
  G7,
  G8,
  Image307,
  Image339,
} from "../../images/Industries";
import { useEffect, useState } from "react";
import { getPagesBySlug } from "../../services/apiService";
import useSlug from "../SlugComp";
import SEO from "../Seo";

const keyPriorities = [
  "Modernizing outdated IT and legacy systems",
  "Safeguarding sensitive citizen and agency data",
  "Meeting strict regulatory and compliance mandates (NIST, CIS, HIPAA, GDPR)",
  "Enhancing operational efficiency through automation",
];

const AIDemand = [
  "Proven track record with large-scale government projects",
  "MWBE-certified, ISO 9001:2015 and ISO/IEC 27001:2022 accredited partner",
  "Hybrid U.S.–India delivery model for cost-effective, round-the-clock support",
  "Expertise in cyberSecurity, compliance, and digital transformation",
];

const features = [
  {
    icon: G1,
    title: "Secure Cloud Adoption",
    desc: "Migrate to cloud with confidence and scalability",
  },
  {
    icon: G2,
    title: "CyberSecurity & 24/7 SOC",
    desc: "Proactive monitoring and rapid incident response",
  },
  {
    icon: G3,
    title: "Risk & Compliance Programs",
    desc: "Aligned with NIST, CIS, PCI DSS, HIPAA",
  },
  {
    icon: G4,
    title: "Vendor Risk Management",
    desc: "Reduce third-party vulnerabilities with TPRM",
  },
  {
    icon: G5,
    title: "Digital Citizen Services",
    desc: "Simplified workflows and online experiences",
  },
];

const impactStories = [
  {
    icon: G6,
    title: "NYC Department of Education",
    desc: "CyberSecurity modernization achieving full NIST compliance",
  },
  {
    icon: G7,
    title: "State Agency",
    desc: "Vendor risk reduced by 35% with TPRM implementation",
  },
  {
    icon: G8,
    title: "Public Housing Authority",
    desc: "Digital workflow automation → improved citizen service delivery",
  },
];

function GPS() {
  const navigate = useNavigate();
  const slug = useSlug();
  const [metaData, setMetaData] = useState({});
  useEffect(() => {
    const fetchMetaData = async () => {
      const data = await getPagesBySlug(slug);
      setMetaData(data?.meta || {});
    };
    fetchMetaData();
  }, [slug]);

  const handleClick = () => {
    navigate("/contact");
  };
  return (
    <>
      <SEO {...metaData} />
      <div>
        <div className="relative min-h-[500px]">
          <img
            src={Banner}
            alt="About Banner"
            className="absolute inset-0 -z-10 md:h-full h-[calc(100vh-0px)] w-full object-cover"
          />

          <div className="absolute flex items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto left-0 right-0 px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
            <div className="max-w-[46rem] font-roboto space-y-6 mt-16">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
                <span className="text-[#475569]">
                  Government & Public Sector
                </span>
              </span>
              <h1 className="text-4xl md:text-7xl text-[#29327f] font-bold">
                Powering Digital Trust for Governments
              </h1>
              <p className="text-md text-[#404040]">
                Ensuring full compliance with NewYork City Cyber Command and
                Citywide IT standards, New York State ITS regulations, and
                Federal frameworks including NIST, FedRAMP, and FISMA.
              </p>
            </div>

            <div className="max-w-xl flex justify-end mt-16">
              <img src={Image339} alt="Image" className="obkect-contain" />
            </div>
          </div>
        </div>

        <section className="py-14 px-4 md:px-20 font-roboto bg-[#F7F7F7]">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto items-center md:items-center justify-between md:px-0 px-6 gap-10">
            <div className="mb-12">
              <h2 className="text-6xl font-extrabold text-[#434253] mb-3">
                Key Priorities We Address
              </h2>
            </div>

            <div className="flex flex-col lg:flex-row items-center gap-10">
              <div className="flex-1 flex items-center justify-center">
                <img
                  src={Image306}
                  alt="Idea Concept"
                  className="max-w-md w-full object-contain"
                />
              </div>

              <div className="flex-1 w-full mb-10">
                <ul className="space-y-7 ms-5">
                  {keyPriorities.map((item, idx) => (
                    <li
                      key={idx}
                      className="list-disc text-xl text-[#0F172A] font-medium"
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto bg-white py-16 px-2 font-roboto">
          <div className="flex justify-center mb-3">
            <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
              <span className="w-[21px] h-[6px] bg-activeColor"></span>
              <span className="w-[36px] h-[6px] bg-activeColor"></span>
            </span>
          </div>
          <h2 className="text-5xl md:text-7xl font-extrabold text-[#434253] text-center mb-4">
            How We Help Governments
          </h2>
          <p className="text-center text-lg max-w-4xl mx-auto text-[#404040] mb-14 font-400">
            We empower businesses with AI-driven tools and automation that
            optimize operations, enhance customer experiences, and unlock
            measurable value across the supply chain:
          </p>

          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
            {features.slice(0, 3).map((feature, idx) => (
              <div
                key={idx}
                className="flex flex-col items-center bg-[#E2EEFF] rounded-xl p-8 shadow-sm"
              >
                <div className="mb-4">
                  <img src={feature.icon} alt={feature.title} />
                </div>
                <div className="font-bold text-xl text-[#0F172A] mb-2 text-center">
                  {feature.title}
                </div>
                <div className="text-lg text-[#0F172A] text-center">
                  {feature.desc}
                </div>
              </div>
            ))}
          </div>
          <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 mt-8 px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
            {features.slice(3).map((feature, idx) => (
              <div
                key={idx}
                className="flex flex-col items-center bg-[#E2EEFF] rounded-xl p-8 shadow-sm"
              >
                <div className="mb-4">
                  <img src={feature.icon} alt={feature.title} />
                </div>
                <div className="font-bold text-xl text-[#0F172A] mb-2 text-center">
                  {feature.title}
                </div>
                <div className="text-lg text-[#0F172A] text-center">
                  {feature.desc}
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="py-14 px-4 md:px-20 font-roboto bg-[#F7F7F7]">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto items-center md:items-center justify-between md:px-0 px-6 gap-10">
            <div className="flex justify-center mb-3">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
              </span>
            </div>
            <h2 className="text-5xl md:text-7xl font-extrabold text-[#434253] text-center mb-6">
              Why Public Agencies Choose TechProjects
            </h2>
            {/* <p className="text-center text-lg max-w-4xl mx-auto text-[#404040] mb-14 font-400">
            Wholesale Grocery Leader – AI Demand Forecasting
          </p> */}

            <div className="flex flex-col lg:flex-row items-center gap-10">
              <div className="flex-1 w-full mb-10">
                <ul className="space-y-7 ms-5">
                  {AIDemand.map((item, idx) => (
                    <li
                      key={idx}
                      className="list-disc text-xl text-[#0F172A] font-medium"
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="flex-1 flex items-center justify-center">
                <img
                  src={Image307}
                  alt="Wholesale Grocery Leader – AI Demand Forecasting"
                  className="max-w-md w-full object-contain"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto bg-white py-16 px-2 font-roboto">
          <div className="flex justify-center mb-3">
            <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
              <span className="w-[21px] h-[6px] bg-activeColor"></span>
              <span className="w-[36px] h-[6px] bg-activeColor"></span>
            </span>
          </div>
          <h2 className="text-5xl md:text-7xl font-extrabold text-[#434253] text-center mb-4">
            Impact Stories
          </h2>
          {/* <p className="text-center text-lg max-w-4xl mx-auto text-[#404040] mb-14 font-400">
          Wholesale Grocery Leader – AI Demand Forecasting
        </p> */}

          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
            {impactStories.slice(0, 3).map((feature, idx) => (
              <div
                key={idx}
                className="flex flex-col items-center bg-[#E7F1FF] rounded-xl p-8 shadow-sm"
              >
                <div className="mb-4">
                  <img src={feature.icon} alt={feature.title} />
                </div>
                <div className="font-bold text-xl text-[#0F172A] mb-2 text-center">
                  {feature.title}
                </div>
                <div className="text-lg text-[#0F172A] text-center">
                  {feature.desc}
                </div>
              </div>
            ))}
          </div>
        </section>

        <section
          className="text-white flex items-center py-8 md:py-[4rem] relative overflow-hidden bg-cover bg-no-repeat font-roboto"
          style={{ backgroundImage: `url(${BlueLarge})` }}
        >
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto text-center px-3 md:px-6">
            <h2 className="text-3xl md:text-4xl xl:text-6xl max-w-6xl mx-auto font-extrabold text-white leading-tight mb-[2rem] md:mb-[3rem]">
              Government & Public Sector
            </h2>
            <p className="text-lg font-400 text-[#CBD5E1] max-w-5xl  mx-auto">
              With TechProjects, you can modernize service delivery, streamline
              operations, and improve citizen engagement — enabled by AI and
              intelligent automation.
            </p>
            <div className="flex flex-wrap  justify-center mt-10 gap-6 md:gap-12">
              <button
                onClick={handleClick}
                type="submit"
                className="bg-activeColor text-white text-lg md:text-2xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium hover:bg-red-600 transition-all flex items-center gap-4"
              >
                Get in Touch
              </button>
            </div>
          </div>
        </section>
        <ScrollToTopButton />
      </div>
    </>
  );
}

export default GPS;
